/**
 * Defines the types Sites.
 */

export interface ISiteTag {
  _id?: string;
  entity_id: string;
  name: string;
  metadata_type: string;
  usage_type: string;
  auto_assign_to_data: string;
  background_color: string;
  text_color: string;
  description: string;
}

export interface ISite {
  id?: string;
  type: string;
  business_type?: string;
  name: string;
  subscriptions?: string[];
  subscriptions_data?: any[];
  all_active_and_inactive_subscriptions: string[];
  phone_settings?: any;
  phone_number?: string;
  website?: string;
  email?: string;
  preferred_language: string;
  store_number: string;
  copy_status?: any;
  is_demo: boolean;
  access_code: string;
  automatic_updates: boolean;
  edm_sync: boolean;
  connected_devices?: [];
  apps?: any;
  timezone: string;
  tasks: [];
  status_info?: any;
  children?: ISite[];
  created_at: string;
  identifiers?: any;
}
export enum SiteType {
  Production = 'Production',
  SiteLab = 'Site-Lab',
  QATest = 'QA-Test',
  Training = 'Training',
  Warehouse = 'Warehouse',
  PrimaryWarehouse = 'Primary Warehouse',
  VendingCommissary = 'Vending Commissary',
  SuitePantry = 'Suite Pantry',
}
export interface ISiteRequestBody {
  'x-odata-filter': string;
}
